import Form from "../../utils/form";

export default {
    data() {
        return {
            uri: ''
        };
    },

    methods: {
        saveList(form) {
            form = this.filterCustomFields(form)
            let self = this;
            form.post(route('api.filterLists.store')).then((response) => {
                if (response.status) {
                    self.getToast(1000).fire({
                        type: 'success',
                        title: response.message
                    });
                    window.location = route('lists');
                } else {
                    self.getToast().fire({
                        type: 'error',
                        title: response.message
                    });
                }
            })
                .catch((err) => {
                    console.log(err)
                })
        },
        updateList(form, list) {
            form = this.filterCustomFields(form);
            let self = this;
            form.put(route('api.filterLists.update', {filterList: list.id})).then((response) => {
                if (response.status) {
                    self.getToast(1000).fire({
                        type: 'success',
                        title: response.message
                    });
                    window.location = route('lists');
                } else {
                    self.getToast().fire({
                        type: 'error',
                        title: response.message
                    });
                }
            })
                .catch((err) => {
                    console.log(err)
                })
        },
        initListForm(list, listName) {
            if(!!this.list.filter){
                let filters = JSON.parse(list.filter)
                return new Form({...filters, list_name: listName, object_type: list.object_type, id: list.id})
            }
        },
        filterCustomFields(form) {
            if(Object.keys(form.custom_fields).length > 0){
                let customFields = form.custom_fields;
                for (let propName in customFields) {
                    if (customFields[propName] === null || customFields[propName] === undefined || customFields[propName] === "" || (typeof customFields[propName] === 'object' && customFields[propName].length === 0)) {
                        delete customFields[propName];
                    }
                }
                form.custom_fields = JSON.stringify(customFields)
            }else{
                form.custom_fields = JSON.stringify({})
            }
            return form;
        },
    },
};
